import React, {Dispatch, SetStateAction, useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {PillItem} from 'components/ui-kit/Pills';

import {CustomPills, CustomTitle, Heading, NavigationContainer} from './styled';

type Props = {index: number; setIndex: Dispatch<SetStateAction<number>>};

export const ParticipantTabs = ({index, setIndex}: Props) => {
    const {t} = useTranslation();

    const tabTranslate = (key: string) => t('pages.profile.participant.tabs.' + key);
    const items: PillItem[] = useMemo(
        () => [
            {label: tabTranslate('storage'), cb: () => setIndex(0)},
            {label: tabTranslate('personal'), cb: () => setIndex(1)},
        ],
        [t],
    );

    return (
        <NavigationContainer>
            <Heading>
                <CustomTitle size={4}>{t('pages.profile.participant.title')}</CustomTitle>
            </Heading>
            <CustomPills forceIndex={index} items={items} />
        </NavigationContainer>
    );
};
